import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostBinding } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import moment from 'moment-timezone';
import { Observable, Subscription } from 'rxjs';
import { VizFormModule } from '../common/components/form/form.module';
import { ScrollContainerComponent } from '../common/components/scroll.container/scroll.container.component';
import { date_utils } from '../common/date_utils';
import { FilterMultiComponent, FilterObject } from '../common/filter';
import {
  ListOption,
  ScrollableListComponentBase,
} from '../common/list.component.base';
import { TimeAtom } from '../common/timespan/time_utils';
import { CompareWithMixin } from '../common/utils';
import { AccessUtils, TSpace, TSpaceType } from '../core/entities';
import { SiteLangMixin } from '../core/lang';
import { SitePathMixin } from '../core/site.path.utils';
import { SessionCache } from '../session.cache';
import { SessionService } from '../session.service';
import { formatDisplayTime, SiteFormatMixin } from '../thinkdesks/site.format.mixin';
import { SpaceCard } from './space.card';

class _Base extends ScrollableListComponentBase<TSpace> {}

@Component({
  selector: 'app-space-wizard-result',
  templateUrl: './space.wizard.result.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FilterMultiComponent,
    ScrollContainerComponent,
    FontAwesomeModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatDialogModule,
    MatToolbarModule,
    SpaceCard,
    VizFormModule,
    FormsModule,
    MatDatepickerModule,
    RouterLink,
  ],
})
export class SpaceWizardResultComponent extends SiteLangMixin(
  CompareWithMixin(SitePathMixin(SiteFormatMixin(_Base)))
) {
  _common = _common;
  @HostBinding('class') css = 'max-height';

  filterObject = new FilterObject();

  date = moment();

  allHours = -1;
  hours: { hour: number; text: string }[] = [];
  hour: any = this.allHours;

  area: string;
  district: string;
  capacityMin: number;
  capacityMax: number;
  type: TSpaceType[] = [];

  types: TSpaceType[] = [];
  // district = new FilterMulti();

  displayedColumns: string[] = ['name', 'organization', 'location', 'controls'];

  subscription: Subscription;
  clear() {
    this.filterObject.clear();
    this.refresh();
  }
  constructor(
    override http: HttpClient,
    override elRef: ElementRef,
    private dialog: MatDialog,
    override snackBar: MatSnackBar,
    private cache: SessionCache,
    override session: SessionService,
    private route: ActivatedRoute
  ) {
    super(http, snackBar, elRef);
    let now = moment();
    for (let i = 0; i < 24; i++) {
      let atom = new TimeAtom(i);
      let tt = atom.moment(now);
      this.hours.push({
        hour: atom.toTime(),
        text: formatDisplayTime(this.session,tt),
      });
    }
  }
  override createRequest(options: ListOption): Observable<Object> {
    let queryParam = this.route.snapshot.queryParamMap;

    let query = {
      date: date_utils.toQuery(this.date),
      hour: this.hour,
      type: queryParam.getAll('type'),
      area: queryParam.get('area'),
      district: queryParam.get('district'),
      capacityMin: queryParam.get('capacityMin'),
      capacityMax: queryParam.get('capacityMax'),
    } as any;
    Object.assign(query, this.filterObject.query());

    const url = this._listModifyUrl(
      `/api/public/space-extra/list`,
      {},
      options
    );
    return this.http.post(url, query);
  }
  override ngOnInit() {
    this.cache.loadSpaceTypes((list) => {
      this.types = list;
      this.subscription = this.route.queryParamMap.subscribe((result) => {
        let date = result.get('date');
        this.date = date_utils.fromQuery(date);

        let hour = result.get('hour');
        this.hour = this.allHours;
        if (hour) {
          this.hour = parseInt(hour);
        }
        let type = result.getAll('type');
        this.type = type
          .map((c) => {
            let id = parseInt(c);
            return this.types.find((c) => c.id == id);
          })
          .filter((c) => !!c);
        this.area = result.get('area');
        this.district = result.get('district');

        this.capacityMax = null;
        this.capacityMin = null;
        let s = result.get('capacityMin');
        if (s) {
          this.capacityMin = parseInt(s);
        }
        s = result.get('capacityMax');
        if (s) {
          this.capacityMax = parseInt(s);
        }
        this.refresh();
      });
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  override listFixList(list: TSpace[]) {
    for (let o of list) AccessUtils.fixSpace(o);
  }

  override selectObject(o: TSpace) {}

  test() {

  }
}
